import { ConcreteTestSet } from '../../../../../ConcreteTestSetTrackerContext/types'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { HelpMessage } from 'utils/constants'
import CIMSLink from 'components/CIMSLink'
import { Report } from '@cims-online/shared'
import { useReportURLDependencies } from 'hooks/useReportURLDependencies'

export function useColumns(): CIMSColumn<
  ConcreteTestSet['concretePlacements'][0]
>[] {
  const help = HelpMessage.Concrete.ConcreteTestSetTracker.Placements
  const dependencies = useReportURLDependencies()

  return [
    {
      title: 'Placement ID',
      width: 154,
      help: help.PlacementID,
      render: ({ globalId, placementId }) => (
        <CIMSLink
          external
          href={Report.ConcretePlacementCoreSheet.toURL({
            globalId,
            ...dependencies,
          })}
          tooltip={Report.ConcretePlacementCoreSheet.name}
        >
          {placementId}
        </CIMSLink>
      ),
      sort: {
        with: 'key',
        key: 'placementId',
        default: 'ascend',
      },
    },
    {
      title: 'Start Location',
      help: help.StartLocation,
      width: 142,
      render: ({ beginStation, beginOffset }) =>
        `${beginStation} ${beginOffset}`,
    },
    {
      title: 'Start Alignment',
      help: help.StartAlignment,
      width: 151,
      render: 'beginAlignment',
    },
    {
      title: 'End Location',
      help: help.EndLocation,
      width: 136,
      render: ({ endStation, endOffset }) => `${endStation} ${endOffset}`,
    },
    {
      title: 'End Alignment',
      help: help.EndAlignment,
      width: 146,
      render: 'endAlignment',
    },
    {
      title: 'Steel Check',
      help: help.SteelCheck,
      width: 130,
      render: 'steelVerified',
    },
    {
      title: 'Cure Coverage',
      help: help.CureCoverage,
      width: 149,
      render: 'cureCoverage',
    },
    {
      title: 'Notes',
      width: 250,
      help: help.Notes,
      render: 'notes',
    },
  ]
}
